export class MobileAppReleaseApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getMobileAppRelease({ companyId }) {
    return this.#http.get(`/api/companies/${companyId}/mobile-app-release`);
  }

  async updateMobileAppRelease({ companyId, ...body }) {
    return this.#http.put(`/api/companies/${companyId}/mobile-app-release`, body);
  }

  async turnOnMobileAppRelease({ companyId, ...body }) {
    return this.#http.post(`/api/companies/${companyId}/mobile-app-release/turn-on`, body);
  }

  async getMobileAppReleaseEvents({ companyId }) {
    return this.#http.get(`/api/companies/${companyId}/mobile-app-release/events`);
  }

  async getIosPushCertificateStatus({ companyId }) {
    return this.#http.get(`/api/companies/${companyId}/mobile-app-release/ios-push-certificate`);
  }

  async uploadIosPushCertificate({ companyId, formData }) {
    return this.#http.post(
      `/api/companies/${companyId}/mobile-app-release/ios-push-certificate`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
  }
}
